import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon } from '@material-ui/icons';
import { css } from '@emotion/css';
import { Divider, Typography } from '@material-ui/core';

const DropdownSectionNested = ({ title, data, dataSelected, handleChange, htmlStaticStyle }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <>
      {/* Titre principal avec icône */}
      <div style={htmlStaticStyle.sectionSidebar}>
        <p
          style={htmlStaticStyle.titleSettingSidebar}
          className={css({
            marginBottom: isOpen ? '15px' : '0px',
            cursor: 'pointer',
            transition: 'all 0.2s',
          })}
          onClick={toggleDropdown}
        >
          {title}
          {isOpen ? (
            <ExpandLessIcon style={htmlStaticStyle.dropdownIcon} />
          ) : (
            <ExpandMoreIcon style={htmlStaticStyle.dropdownIcon} />
          )}
        </p>

        {/* Contenu avec les sous-sections */}
        {isOpen && (
          <div>
            {data.map(({ label, skills }) => (
              <div key={label} style={{ marginBottom: '10px' }}>
                {/* Titre de la sous-section */}
                <Typography
                  variant="h6"
                  style={{
                    fontSize: '14px',
                    marginBottom: '5px',
                    fontWeight: 600,
                    color: '#152652',
                  }}
                >
                  {label}
                </Typography>

                {/* Liste des compétences */}
                <div style={htmlStaticStyle.containerChoiseInSettingSidebar}>
                  {skills.map((skill) => (
                    <label key={skill.id} style={htmlStaticStyle.subTitleSettingSidebar}>
                      <input
                        type="checkbox"
                        id={`skill-${skill.id}`}
                        style={{ marginRight: '5px' }}
                        onChange={() => handleChange(skill)}
                        checked={dataSelected.includes(skill)}
                      />
                      {skill.label}
                    </label>
                  ))}
                </div>
                <Divider style={{ marginTop: '5px' }} />
              </div>
            ))}
          </div>
        )}
      </div>
      <hr style={{ margin: '0' }} color='#C0D9FF' />
    </>
  );
};

DropdownSectionNested.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  dataSelected: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
  htmlStaticStyle: PropTypes.object.isRequired,
};

export default DropdownSectionNested;
